import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";
import userSlice from "src/store/userSlice";
import layoutSlice from "src/store/layoutSlice";
import templateCreationSlice from "src/store/templateCreationSlice";
import inspectionTemplateSlice from "src/store/inspectionTemplateSlice";
import inspectionSlice from "src/store/inspectionSlice";
import inspectionCaptureSlice from "src/store/inspectionCaptureSlice";
import inspectionResultsSlice from "src/store/inspectionResultsSlice";

export const reducers = {
  user: userSlice,
  layout: layoutSlice,
  templateCreation: templateCreationSlice,
  inspectionTemplate: inspectionTemplateSlice,
  inspection: inspectionSlice,
  inspectionCapture: inspectionCaptureSlice,
  inspectionResults: inspectionResultsSlice,
};

const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // to allow non serializable objects to be stored in redux (eg: Map, Set, classes etc.)
    }),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
